import { useState, useEffect, useRef } from "react";

import { useLocation } from "react-router-dom";

import { PROFILE_UI_CONTENT } from "./profileContextContent";
import { resolveProfileUIText } from "./resolveProfileUIText";


import RegistrationStepLayout from "./RegistrationStepLayout";

import {

     getCountryList,
     getStateList,
     getCityList,
    submitNativeAddress,
    getDomainList,
    getReligionByDomain,
    getCasteByReligion,
    submitCommunityDetails,
     } from "../../javaAxiosConfig";


import NativeAddressIcon from "../../images/nativeAddressIcon.png";
import CommunityIcon from "../../images/communityIcon.png";

import infoIcon from "../../images/i-buton.png";

import searchIcon from "../../images/searchIcon.svg";
import upArrow from "../../images/updropArrow.png";
import downArrow from "../../images/downdropArrow.png";
import { justifyContent, width } from "@mui/system";

/* =====================================================
   PARENT – NATIVE ADDRESS FLOW
===================================================== */

const NativeAddressFlow = ({ onCompleted }) => {

  console.log("[NAF] mount", {
  registrationProgress: localStorage.getItem("registrationProgress"),
  resumeMode: localStorage.getItem("resumeMode"),
});

  const [step, setStep] = useState(1);

  const [slideClass, setSlideClass] = useState("");
const prevStepRef = useRef(step);


// useEffect(() => {
//   const progress = localStorage.getItem("registrationProgress");
//   const isResume =
//   localStorage.getItem("resumeMode") === "true" &&
//   localStorage.getItem("loginType") === "login";


//   console.log("[NAF] effect start", { progress, isResume });

//   // ✅ NORMAL FLOW → ALWAYS start with Native Address
//   if (!isResume) {
//     console.log("[NAF] normal flow → Native Address");
//     setStep(1);
//     return;
//   }

//   // ✅ LOGIN RESUME ONLY
//   if (progress === "NATIVE_ADDRESS_CHECK") {
//     console.log("[NAF] resume login → jump to Community");
//     setStep(2);
//     return;
//   }

//   setStep(1);
// }, []);


// useEffect(() => {
//   const progress = localStorage.getItem("registrationProgress");

//   console.log("[NAF] progress check:", progress);

//   // If Native already submitted → jump to Community
//   if (progress === "NATIVE_ADDRESS_CHECK") {
//     setStep(2);
//   } else {
//     setStep(1);
//   }
// }, []);

useEffect(() => {
  const progress = localStorage.getItem("registrationProgress");
  const loginType = localStorage.getItem("loginType");
  const isResume = localStorage.getItem("resumeMode") === "true";

  console.log("[NAF] progress check:", progress, "isResume:", isResume);

  // If community completed → exit
  if (progress === "COUMMUNITY_DETAILS_CHECK") {
    onCompleted();
    return;
  }

  // LOGIN + API says Native complete
  if (
    loginType === "login" &&
    isResume &&
    progress === "NATIVE_ADDRESS_CHECK"
  ) {
    console.log("[NAF] Login user → Skip Native → Community");
    setStep(2);
    return;
  }

  // Fresh registration
  console.log("[NAF] Show Native");
  setStep(1);
}, []);

useEffect(() => {
  if (prevStepRef.current === step) return;

  const isForward = step > prevStepRef.current;

  setSlideClass(isForward ? "slide-forward" : "slide-backward");

  const timer = setTimeout(() => {
    setSlideClass("");
  }, 500); // smooth premium 450–500ms

  prevStepRef.current = step;

  return () => clearTimeout(timer);
}, [step]);




  const next = () => setStep((s) => s + 1);
  const back = () => setStep((s) => Math.max(1, s - 1));


  const profileCreatedById = Number(localStorage.getItem("profileCreatedById"));
const gender = localStorage.getItem("selectedGender");

const getResolvedNativeText = (stepKey) => {
  const stepConfig = PROFILE_UI_CONTENT?.[stepKey];
  if (!stepConfig) return { title: "", subtitle: "" };

  return resolveProfileUIText({
    profileCreatedById,
    gender,
    stepKey,
    stepConfig,
  });
};


  return (
    <>
    
<div className={`registration-anim-wrapper ${slideClass}`}>

{step === 1 && (() => {
  const resolved = getResolvedNativeText("NATIVE_PLACE");

  return (
    <NativeAddressStep
      title={resolved.title}
      subtitle={resolved.subtitle}
      onNext={() => setStep(2)}
    />
  );
})()}

{step === 2 && (() => {
  const resolved = getResolvedNativeText("COMMUNITY");

  return (
    <CommunityDetailsStep
      title={resolved.title}
      subtitle={resolved.subtitle}
      onBack={() => setStep(1)}
      onCompleted={onCompleted}
    />
  );
})()}

</div>
    </>
  );
};

export default NativeAddressFlow;



/* =====================================================
   COMMON STYLES (same pattern as Education flow)
===================================================== */


const cardStyle = {
  width: "100%",
  marginTop:"20px",
  maxWidth: 500,
  borderRadius: 15,
  border: "1px solid #e8e6ea",
  padding: "20px",
  boxSizing: "border-box",
  position: "relative",
};


const inputBoxStyle = {
  height: 50,
  borderRadius: 12,
  width: "100%",
  border: "1px solid #e8e6ea",
  display: "flex",
  alignItems: "center",
  padding: "0 16px",
  marginTop: 10,
//   color: "#777",
};

const errorTextStyle = {
  color: "#ff3c3c",
  fontSize: "12px",
  marginTop: "6px",
  fontFamily: "Montserrat",
};


const infoBoxStyle = {
  marginTop: 120,
  width: "100%",
  padding: 14,
  border: "1px dashed rgba(230,0,0,0.5)",
  borderRadius: 12,
  fontSize: 12,
  color: "#555",
  textAlign: "center",
  justifyContent: "center",
};

/* =====================================================
   STEP 1 – NATIVE ADDRESS
===================================================== */

const NativeAddressStep = ({ onNext, title, subtitle }) => {
  const [country, setCountry] = useState(null);
  const [citizenship, setCitizenship] = useState(null);
  const [state, setState] = useState(null);
  const [city, setCity] = useState(null);

  const [house, setHouse] = useState("");
  const [area, setArea] = useState("");

  const [errors, setErrors] = useState({});

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [showCountry, setShowCountry] = useState(false);
  const [showCitizenship, setShowCitizenship] = useState(false);
  const [showState, setShowState] = useState(false);
  const [showCity, setShowCity] = useState(false);

  /* ---------- FETCH ---------- */

//   useEffect(() => {
//     getCountryList().then(res =>
//       setCountries((res.data || []).filter(i => i.isActive))
//     );
//   }, []);

useEffect(() => {
  getCountryList().then(res => {
    const activeCountries = (res.data || []).filter(i => i.isActive);
    setCountries(activeCountries);

    // ✅ PRESELECT INDIA FOR BOTH
    const india = activeCountries.find(c => c.id === 233);

    if (india) {
      setCountry(india);
      setCitizenship(india);

      // clear any validation errors
      setErrors(prev => {
        const e = { ...prev };
        delete e.country;
        delete e.citizenship;
        return e;
      });
    }
  });
}, []);


  useEffect(() => {
    if (!country) return;
    getStateList(country.id)
      .then(res => setStates((res.data || []).filter(i => i.isActive)))
      .catch(() => setStates([]));
  }, [country]);

  useEffect(() => {
    if (!state) return;
    getCityList(state.id)
      .then(res => setCities((res.data || []).filter(i => i.isActive)))
      .catch(() => setCities([]));
  }, [state]);

  /* ---------- VALIDATION ---------- */

  const validate = () => {
    const e = {};
    if (!country) e.country = "Please select country";
    if (!citizenship) e.citizenship = "Please select citizenship";
    if (!state) e.state = "Please select state";
    if (!city) e.city = "Please select city";
    // if (!house.trim()) e.house = "House / Building is required";
    // if (!area.trim()) e.area = "Area is required";

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  /* ---------- SUBMIT ---------- */

  const handleContinue = async () => {

     console.log("[NAF] NativeAddress submit clicked");
  if (!validate()) {
    console.log("[NAF] validation failed");
    return;
  }
    await submitNativeAddress({
      countryId: country.id,
      stateId: state.id,
      cityId: city.id,
      citizenship: citizenship.id,
      streetAddress: house,
      area,
    });

      console.log("[NAF] NativeAddress API success → setting progress");

    // localStorage.setItem("registrationProgress", "NATIVE_ADDRESS_CHECK");
    onNext();
  };

const UnderlineDropdown = ({ label, required, value, onClick }) => (
  <div
    onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}
    style={{
      marginTop: 16,
      cursor: "pointer",
    }}
  >
    {/* LABEL / VALUE + ARROW */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: 15,
        color: value ? "#000" : "#a9a9a9",
        fontWeight: 500,
      }}
    >
      <div>
        {value || label}
        {!value && required && (
          <span style={{ color: "rgba(230,0,0,0.81)" }}> *</span>
        )}
      </div>

      <img src={downArrow} alt="" width={18} />
    </div>

    {/* UNDERLINE */}
    <div
      style={{
        height: 1,
        backgroundColor: "#e8e6ea",
        marginTop: 12,
      }}
    />
  </div>
);


return (
  <RegistrationStepLayout
    icon={NativeAddressIcon}
    // title="Your Native Address"
    // subtitle="This helps us find matches near your location."

    title={title} 
subtitle={subtitle}
    stepText="Step 1 of 2"
    onContinue={handleContinue}
  >
    <div style={cardStyle}>


      {/* CITIZENSHIP */}

      <UnderlineDropdown
  label="Citizenship"
  required
  value={citizenship?.country}
  onClick={() => {
    setShowCitizenship(prev => !prev);
    // setShowCitizenship(true);
    setShowCountry(false);
    setShowState(false);
    setShowCity(false);
  }}
/>
      {errors.citizenship && <ErrorText text={errors.citizenship} />}
      {showCitizenship && (
        <DropdownOverlay
          data={countries}
           topOffset={83} 
          labelKey="country"
          onClose={() => setShowCitizenship(false)}
        //   onSelect={(item) => {
        //     setCitizenship(item);
        //     setShowCitizenship(false);
        //   }}

        onSelect={(item) => {
  setCitizenship(item);
  setErrors(prev => {
    const e = { ...prev };
    delete e.citizenship;
    return e;
  });
  setShowCitizenship(false);
}}

        />
      )}

      {/* COUNTRY */}

      <UnderlineDropdown
  label="Country"
  required
  value={country?.country}
  onClick={() => {
    // setShowCountry(true);
    setShowCountry(prev => !prev);
    setShowCitizenship(false);
    setShowState(false);
    setShowCity(false);
  }}
/>


      {errors.country && <ErrorText text={errors.country} />}
      {showCountry && (
        <DropdownOverlay
          data={countries}
          topOffset={135} 
          labelKey="country"
          onClose={() => setShowCountry(false)}
        //   onSelect={(item) => {
        //     setCountry(item);
        //     setState(null);
        //     setCity(null);
        //     setShowCountry(false);
        //   }}

        onSelect={(item) => {
  setCountry(item);
  setState(null);
  setCity(null);

  setErrors(prev => {
    const e = { ...prev };
    delete e.country;
    delete e.state;
    delete e.city;
    return e;
  });

  setShowCountry(false);
}}

        />
      )}



      {/* CITY + STATE ROW */}

      <div style={{ display: "flex", gap: 40 }}>

        <div style={{ flex: 1 }}>
    <UnderlineDropdown
      label="State"
      required
      value={state?.state}
      onClick={() => {
        // setShowState(true);
        setShowState(prev => !prev);
        setShowCountry(false);
        setShowCitizenship(false);
        setShowCity(false);
      }}
    />

    {errors.state && <ErrorText text={errors.state} />}

    {showState && (
      <DropdownOverlay
        data={states}
        topOffset={185} 
        labelKey="state"
        onClose={() => setShowState(false)}
        // onSelect={(item) => {
        //   setState(item);
        //   setCity(null);
        //   setShowState(false);
        // }}
        onSelect={(item) => {
  setState(item);
  setCity(null);

  setErrors(prev => {
    const e = { ...prev };
    delete e.state;
    delete e.city;
    return e;
  });

  setShowState(false);
}}

      />
    )}
  </div>

  <div style={{ flex: 1 }}>
    <UnderlineDropdown
      label="City"
      required
      value={city?.city}
      onClick={() => {
        // setShowCity(true);
        setShowCity(prev => !prev);
        setShowCountry(false);
        setShowCitizenship(false);
        setShowState(false);
      }}
    />

    {errors.city && <ErrorText text={errors.city} />}

    {showCity && (
      <DropdownOverlay
        data={cities}
        topOffset={185} 
        labelKey="city"
        onClose={() => setShowCity(false)}
        // onSelect={(item) => {
        //   setCity(item);
        //   setShowCity(false);
        // }}

        onSelect={(item) => {
  setCity(item);

  setErrors(prev => {
    const e = { ...prev };
    delete e.city;
    return e;
  });

  setShowCity(false);
}}

      />
    )}
  </div>

  
</div>


      {/* HOUSE */}
      <UnderlineInput
        placeholder="House no. / Building Name"
        value={house}
        // onChange={setHouse}
        onChange={(val) => {
  if (val.length <= 250) {
    setHouse(val);
  }
}}

        error={errors.house}
      />

      {/* ROAD */}
      <UnderlineInput
        placeholder="Road Name / Area / Colony"
        value={area}
        // onChange={setArea}
        onChange={(val) => {
  if (val.length <= 250) {
    setArea(val);
  }
}}

        error={errors.area}
      />
    </div>
  </RegistrationStepLayout>
);

};


const FieldLabel = ({ label, required }) => (
  <div style={{ marginTop: 18, fontSize: 14, color: "#a9a9a9" }}>
    {label}
    {required && <span style={{ color: "rgba(230,0,0,0.81)" }}> *</span>}
  </div>
);

const ErrorText = ({ text }) => (
  <div style={{ color: "#ff3c3c", fontSize: 12, marginTop: 4 }}>
    {text}
  </div>
);

const UnderlineInput = ({ placeholder, value, onChange, error }) => (
  <div style={{ marginTop: 20 }}>
    <input
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        width: "100%",
        border: "none",
        borderBottom: `1px solid ${error ? "#ff3c3c" : "#e8e6ea"}`,
        outline: "none",
        padding: "10px 0",
        fontSize: 15,
        fontFamily: "Montserrat",
      }}
    />
    {error && <ErrorText text={error} />}
  </div>
);
/* =====================================================
   STEP 2 – COMMUNITY DETAILS
===================================================== */

const CommunityDetailsStep = ({ onBack, onCompleted , title, subtitle}) => {
  const [domain, setDomain] = useState(null);
  const [religion, setReligion] = useState(null);
  const [caste, setCaste] = useState(null);

  const [domains, setDomains] = useState([]);
  const [religions, setReligions] = useState([]);
  const [castes, setCastes] = useState([]);

  const [showDomain, setShowDomain] = useState(false);
  const [showReligion, setShowReligion] = useState(false);
  const [showCaste, setShowCaste] = useState(false);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    getDomainList().then(res =>
      setDomains((res.data || []).filter(i => i.isActive))
    );
  }, []);

//   useEffect(() => {
//     if (!domain) return;
//     getReligionByDomain(domain.id).then(res =>
//       setReligions((res.data || []).filter(i => i.isActive))
//     );
//   }, [domain]);

useEffect(() => {
  if (!domain?.id) {
    setReligions([]);
    setReligion(null);
    setCastes([]);
    setCaste(null);
    return;
  }

  getReligionByDomain(domain.id)
    .then((res) => {
      setReligions((res.data || []).filter(i => i.isActive));
      setReligion(null);
      setCastes([]);
      setCaste(null);
    })
    .catch(() => {

      setReligions([]);
      setReligion(null);
      setCastes([]);
      setCaste(null);
    });
}, [domain]);


//   useEffect(() => {
//     if (!religion) return;
//     getCasteByReligion(religion.id).then(res =>
//       setCastes((res.data || []).filter(i => i.isActive))
//     );
//   }, [religion]);

useEffect(() => {
  if (!religion?.id) {
    setCastes([]);
    setCaste(null);
    return;
  }

  getCasteByReligion(religion.id)
    .then((res) => {
      setCastes((res.data || []).filter(i => i.isActive));
      setCaste(null);
    })
    .catch(() => {
      // 🔥 EMPTY caste list is allowed, UI handles it
      setCastes([]);
      setCaste(null);
    });
}, [religion]);



  const validate = () => {
    const e = {};

    if (!domain) e.domain = "Please select domain";
    if (!religion) e.religion = "Please select religion";
    if (!caste) e.caste = "Please select caste";

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleContinue = async () => {

     console.log("[NAF] Community submit clicked");

    if (!validate()) return;

    await submitCommunityDetails({
      domainId: domain.id,
      religionId: religion.id,
      casteId: caste.id,
    });

     console.log("[NAF] Community completed → calling onCompleted");
     
    // localStorage.setItem(
    //   "registrationProgress",
    //   "COUMMUNITY_DETAILS_CHECK"
    // );

    onCompleted();
  };

  return (
    <RegistrationStepLayout
      icon={CommunityIcon}
      // title="Your Community Details"
      // subtitle="This helps us show you better cultural matches."

      title={title} 
subtitle={subtitle}
      stepText="Step 2 of 2"
    //   onBack={onBack}
      onContinue={handleContinue}
      continueVariant="button"
    >
      {/* DOMAIN */}
      <DropdownInput
        label={domain?.domain || "Select Domain *"}
        open={showDomain}
        // onClick={() => setShowDomain(true)}
        onClick={() => {
  setShowDomain((prev) => !prev);
  setShowReligion(false);
  setShowCaste(false);
}}

      />
      {errors.domain && <div style={errorTextStyle}>{errors.domain}</div>}
      {showDomain && (
        <DropdownOverlay
          data={domains}
          topOffset={157} 
          labelKey="domain"
          onClose={() => setShowDomain(false)}
          onSelect={(item) => {
            setDomain(item);
            setReligion(null);
            setCaste(null);

              setErrors(prev => {
    const e = { ...prev };
    delete e.domain;
    delete e.religion;
    delete e.caste;
    return e;
  });
            setShowDomain(false);
          }}
        />
      )}

      {/* RELIGION */}
     <DropdownInput
  label={religion?.religion || "Select Religion *"}
  open={showReligion}
  onClick={() => {
    setShowReligion((prev) => !prev);
    setShowDomain(false);
    setShowCaste(false);
  }}
/>

      {errors.religion && <div style={errorTextStyle}>{errors.religion}</div>}
      {showReligion && (
        <DropdownOverlay
          data={religions}
          topOffset={226} 
          labelKey="religion"
          onClose={() => setShowReligion(false)}
          onSelect={(item) => {
            setReligion(item);
            setCaste(null);

              setErrors(prev => {
    const e = { ...prev };
    delete e.religion;
    delete e.caste;
    return e;
  });

            setShowReligion(false);
          }}
        />
      )}

      {/* CASTE */}
      <DropdownInput
  label={caste?.caste || "Select Caste *"}
  open={showCaste}
  onClick={() => {
    setShowCaste((prev) => !prev);
    setShowDomain(false);
    setShowReligion(false);
  }}
/>


      {errors.caste && (
  <div style={errorTextStyle}>{errors.caste}</div>
)}

      {showCaste && (
        <DropdownOverlay
          data={castes}
           topOffset={255} 
          labelKey="caste"
          onClose={() => setShowCaste(false)}
          onSelect={(item) => {
            setCaste(item);

             setErrors(prev => {
    const e = { ...prev };
    delete e.caste;
    return e;
  });
            setShowCaste(false);
          }}
        />
      )}

      {/* <div style={infoBoxStyle}>
        These details are only used for match suggestions.
      </div> */}

        <div
  style={{
    ...infoBoxStyle,
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
  }}
>
  <img
    src={infoIcon}
    alt="info"
    style={{
      width: 22,
      height: 22,
      flexShrink: 0,
      marginTop: 0,
    }}
  />

  <span style={{ lineHeight: "1.98", textAlign: "left",}}>
Community details are used to show matches aligned with your background.  </span>
</div>
    </RegistrationStepLayout>
  );
};









/* =====================================================
   common dorpdown and input ui
===================================================== */

const DropdownInput = ({ label, open, onClick }) => {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation(); // 🔥 IMPORTANT
        onClick();
      }}
      style={{
        marginTop: 12,
        width: "100%",
        height: 57,
        borderRadius: 13,
        border: "1px solid #e8e6ea",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 20px",
        cursor: "pointer",
        fontWeight: 500,
        color: "rgba(0,0,0,0.7)",
      }}
    >
      {label}
      <img src={open ? upArrow : downArrow} alt="" width={18} />
    </div>
  );
};


const DropdownOverlay = ({ data, labelKey, onClose, onSelect , topOffset = 28,}) => {
  const ref = useRef();
  const [search, setSearch] = useState("");

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

//   const filteredData = data.filter((item) =>
//     item[labelKey].toLowerCase().includes(search.toLowerCase())
//   );

const filteredData = (data || []).filter(
  (item) =>
    item[labelKey] &&
    item[labelKey].toLowerCase().includes(search.toLowerCase())
);


  return (
    <div
      ref={ref}
      onClick={(e) => e.stopPropagation()}
      style={{
        position: "absolute",
        // top: 80,
         top: topOffset,
        left: 0,
        width: "100%",
        maxWidth: 500,
        height: 280,
        borderRadius: 15,
        background: "#fffcfb",
        border: "1px solid #e8e6ea",
        animation: "fadeIn 0.2s ease",

        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        zIndex: 10000,
      }}
    >
      {/* SEARCH */}
      <div
        style={{
          margin: 15,
          height: 43,
          borderRadius: 50,
          border: "1px solid #eee",
          display: "flex",
          alignItems: "center",
          padding: "0 12px",
          gap: 10,
          boxShadow: "0px 4px 12px rgba(13,10,44,0.06)",
        }}
      >
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search ..."
          style={{
            flex: 1,
            border: "none",
            outline: "none",
            background: "transparent",
            fontSize: 13,
          }}
        />
        <img src={searchIcon} alt="" width={28} />
      </div>

      {/* LIST */}
      <div style={{ 
         flex: 1,                   
          overflowY: "auto",         
          paddingBottom: 1,         
        }}>

        {/* {filteredData.map((item, i) => (
          <div key={i}>
            <div
            //   onClick={() => onSelect(item[labelKey])}
            onClick={() => onSelect(item)}

              style={{
                padding: "14px 45px",
                cursor: "pointer",
                fontWeight: 500,
              }}
            >
              {item[labelKey]}
            </div>

            <div
              style={{
                height: 0.3,
                margin: "0 35px",
                background:
                  "linear-gradient(90deg, rgba(255,119,5,0), rgba(230, 0, 0, 0.53), rgba(255,119,5,0))",
              }}
            />
          </div>
        ))} */}

        {filteredData.length === 0 ? (
  <div
    style={{
      padding: "30px",
      textAlign: "center",
      fontSize: "13px",
      color: "#999",
      fontFamily: "Montserrat",
    }}
  >
    No options available
  </div>
) : (
  filteredData.map((item, i) => (
    <div key={i}>
      <div
        onClick={() => onSelect(item)}
        style={{
          padding: "14px 45px",
          cursor: "pointer",
          fontWeight: 500,
        }}
      >
        {item[labelKey]}
      </div>

      <div
        style={{
          height: 1.2,
          margin: "1px 35px",
          background:
            "linear-gradient(90deg, rgba(255,119,5,0), rgba(230,0,0,0.53), rgba(255,119,5,0))",
        }}
      />
    </div>
  ))
)}


      </div>
    </div>
  );
};


